var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTickCall(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "20px",
    viewBox: "0 0 26 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icTickCall") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.295384615,10.56 C0.0984615385,10.368 0,10.08 0,9.888 C0,9.696 0.0984615385,9.408 0.295384615,9.216 L1.67384615,7.872 C2.06769231,7.488 2.65846154,7.488 3.05230769,7.872 L3.15076923,7.968 L8.56615385,13.632 C8.76307692,13.824 9.05846154,13.824 9.25538462,13.632 L22.4492308,0.288 L22.5476923,0.288 L22.5476923,0.288 C22.9415385,-0.096 23.5323077,-0.096 23.9261538,0.288 L25.3046154,1.632 C25.6984615,2.016 25.6984615,2.592 25.3046154,2.976 L25.3046154,2.976 L9.55076923,18.912 C9.35384615,19.104 9.15692308,19.2 8.86153846,19.2 C8.56615385,19.2 8.36923077,19.104 8.17230769,18.912 L0.492307692,10.848 L0.295384615,10.56 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Voice-call---receiving",
    transform: "translate(-214.000000, -675.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-28",
    transform: "translate(30.000000, 579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(25.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(132.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icTickCall",
    transform: "translate(27.200000, 30.400000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/light-green",
    mask: "url(#mask-2)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.200000, -30.400000)",
    id: "colour/light-grey"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 80 0 80 80 0 80"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTickCall);
export default __webpack_public_path__ + "static/media/icTickCall.ccdcc93d76ab152660845c71fa9a91b3.svg";
export { ForwardRef as ReactComponent };